import { useQuery } from "@tanstack/react-query"

import { getMarketingConsent } from "data/fetch/user/marketingConsent"

import { setStaleTimeInMinutes } from "../helpers"
import { queries } from "../keys"

export const useMarketingConsentQuery = (userId, enabled = true) =>
  useQuery({
    queryKey: queries.user.marketingConsent(userId).queryKey,
    queryFn: () => getMarketingConsent(userId),
    enabled,
    staleTime: setStaleTimeInMinutes(5),
  })

export default { useMarketingConsentQuery }
